<template>
	<canvas :id="`canvas-${areaId}`" :width="width" height="350"></canvas>
</template>
<script>
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-trailing-spaces */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-undef */
/* eslint-disable no-use-before-define */
/* eslint-disable no-underscore-dangle */
/* eslint-disable quotes */
/* eslint-disable no-plusplus */
/* eslint-disable eqeqeq */
/* eslint-disable padded-blocks */


function showGraph(dataInput, canvas, options) {
	const ctx = canvas.getContext('2d');
	const data = dataInput.map(d => {
		d.color = d.color || '#5ed52b';
		return d;
	});
	const sorter = (a, b) => {
		if (a.color > b.color) {
			return 1;
		} else if (a.color < b.color) {
			return -1;
		}
		return 0;
	};
	data.sort(sorter);
	options.style = data.length > 3 ? 'area' : 'lines';
	const groupedData = groupData(data);
	if (!ctx) {
		const err = 'Context canvas 2d needed';
		throw err;
	}
	// Util
	function getVectorDirection(angle) {
		return {
			x: Math.cos(angle),
			y: Math.sin(angle),
		};
	}
	function lerp(a, b, t) {
		return (b - a) * t + a;
	}

	const radius = options.radius;
	const lines = options.lines;
	const maxValue = options.maxValue;
	const ease = options.ease;
	const duration = options.duration;
	// Properties
	const total = data.length;
	const width = canvas.width;
	const height = canvas.height;
	const centerX = width / 2;
	const centerY = height / 2;
	const lineWidth = 0.6;
	const maxWidthWord = 80;
	const v1 = getVectorDirection(0);
	const v2 = getVectorDirection(1 / total * Math.PI * 2);
	const diff = {
		x: (v1.x + v2.x) / 2,
		y: (v1.y + v2.y) / 2,
	};

	const rad = Math.atan2(diff.y, diff.x);

	function init() {
		// Init graphics properties
		ctx.lineWidth = 1.25;
		ctx.save();
		ctx.translate(centerX, centerY);
		if (total % 2 === 0) {
			if ((total - 6) % 4 === 0) {
				ctx.rotate(-rad);
			} else {
				ctx.rotate(0);
			}
		} else if (total === 3) {
			ctx.rotate(rad / 2);
		} else {
			ctx.rotate(-rad / 2);
		}
	}

	function _calculatePosition(angle, radius, value, maxValue) {
		const x = Math.cos(angle) * radius * value / maxValue;
		const y = Math.sin(angle) * radius * value / maxValue;
		return [x, y];
	}

	function drawData(t) {
		// Draw Data
		ctx.fillStyle = '#FFFFFF';
		ctx.beginPath();

		for (let i = 0; i < total; i += 1) {
			const d = data[i];
			const value = lerp(0, d.value, t);
			const angle = i / total * Math.PI * 2;
      		const [x, y] = _calculatePosition(angle, radius, value, maxValue);
			// First one
			if (i === 0) {
				ctx.moveTo(x, y);
			} else {
				ctx.lineTo(x, y);
			}
		}
		ctx.closePath();
		ctx.fill();
		ctx.stroke();
    	drawLineStyle();
	}
  
	function drawLineStyle() {
		data.forEach((d, i) => {
			const value = lerp(0, d.value, t);
			const angle = i / total * Math.PI * 2;
			const [x, y] = _calculatePosition(angle, radius, value, maxValue);
			ctx.strokeStyle = d.color;
			ctx.lineWidth = 2;
			ctx.lineCap = "round";
			ctx.beginPath();
			ctx.moveTo(0, 0);
			ctx.lineTo(x, y);
			ctx.stroke();
		});
	}
  
	function drawAreas() {
		const total = data.length;
		let i = 0;
		Object.entries(groupedData).forEach((entry, index) => {
			ctx.beginPath();
			ctx.fillStyle = entry[0];
			ctx.lineTo(0, 0);
			entry[1].forEach((d, index2) => {
				const value = lerp(0, d.value, t);
				const angle = i / total * Math.PI * 2;
				const [x, y] = _calculatePosition(angle, radius, value, maxValue);
				ctx.lineTo(x, y);
				i++;
			});
			i--;
			ctx.closePath();
			ctx.stroke();
			ctx.fill();
		});
	}

	function groupData(data) {
		let currentKey;
		let firstKey;
		const reducer = (accumulator, currentValue, index, src) => {
			if (!currentKey) {
				currentKey = currentValue.color;
			}
			if (!firstKey) {
				firstKey = currentValue.color;
			}
			const list = accumulator[currentValue.color] || [];
			list.push(currentValue);
			accumulator[currentValue.color] = list;
			if (currentKey != currentValue.color) {
				accumulator[currentKey].push(currentValue);
			}
			currentKey = currentValue.color;
			if (index == src.length - 1) {
				accumulator[currentValue.color].push(src[0]);
			}
			return accumulator;
		};
		return data.reduce(reducer, {});
	}
	
	function drawText(t) {
		for (let i = 0; i < total; i += 1) {
			const d = data[i];
			const text = d.name.split(' ');
			const value = Math.round(lerp(0, d.value, t) * 100) / 100;
			const textWrap = [];
			let index = 0;
			let maxWidth = 0;
			// Group words
			for (let j = 0; j < text.length; j += 1) {
				const w = text[j];
				if (textWrap.length === 0) {
					textWrap.push(w);
					maxWidth = ctx.measureText(w).width;
				} else {
					const w2 = `${textWrap[index]} ${w}`;
					const wi = ctx.measureText(w2).width;
					if (wi < maxWidthWord) {
						textWrap[index] = w2;
						maxWidth = Math.max(maxWidth, wi);
					} else {
						textWrap.push(w);
						index += 1;
						maxWidth = Math.max(maxWidth, ctx.measureText(w).width);
					}
				}
			}
			const gf = Math.max(maxWidth - maxWidthWord + 25, 0);
			const angle = i / total * Math.PI * 2;
			const x = Math.cos(angle) * (radius * 1.35 + gf);
			const y = Math.sin(angle) * (radius * 1.3);
			ctx.save();
			ctx.translate(x, y);
			let ra2 = 0;
			if (total % 2 === 0) {
				if ((total - 6) % 4 === 0) {
					ra2 = rad;
				} else {
					ra2 = 0;
				}
			} else if (total === 3) {
				ra2 = -rad / 2;
			} else {
				ra2 = rad / 2;
			}
			ctx.rotate(ra2);
			ctx.textAlign = 'center';
			ctx.font = 'bold 10px Arial';
			ctx.fillStyle = '#545a54';
			for (let j = 0; j < textWrap.length; j += 1) {
				const name = textWrap[j];
				ctx.fillText(name, 0, 12 * j);
			}
			ctx.fillStyle = d.color;
			const yR = Math.sin(angle - ra2);
			ctx.font = 'bold 14px Arial';
			if (yR < 0) {
				ctx.fillText(`${value}`, 0, -14);
			} else {
				ctx.fillText(`${value}`, 0, 12 * textWrap.length + 8);
			}
			ctx.restore();
		}
	}
  
  	function drawCircles() {
  
		ctx.strokeStyle = '#545a54';
		for (let j = 1; j <= lines; j += 1) {
			ctx.beginPath();
			for (let i = 0; i < total; i += 1) {
				const angle = i / total * Math.PI * 2;
				const x = Math.cos(angle) * radius * j / lines;
				const y = Math.sin(angle) * radius * j / lines;
				if (i === 0) {
					ctx.moveTo(x, y);
				} else {
					ctx.lineTo(x, y);
				}
			}
			ctx.closePath();
			ctx.stroke();
		}
    
  	}

	function drawLines() {
    
		ctx.strokeStyle = '#545a54';
		for (let i = 0; i < total; i += 1) {
			const angle = i / total * Math.PI * 2;
			const x = Math.cos(angle) * radius;
			const y = Math.sin(angle) * radius;

			ctx.beginPath();
			ctx.moveTo(x, y);
			ctx.lineTo(0, 0);
			ctx.stroke();
		}
	}
	function drawDebug() {
		// Draw debug circle
		ctx.strokeStyle = '#ddaaaa';
		ctx.beginPath();
		ctx.arc(0, 0, radius, 0, Math.PI * 2, true); // outer (unfills it)
		ctx.stroke();

		ctx.beginPath();
		ctx.arc(diff.x * radius, diff.y * radius, 5, 0, Math.PI * 2, true); // outer (unfills it)
		ctx.fill();

		ctx.restore();
	}
	let t = 0;

	(() => {
		(function () {
			const requestAnimationFrame = window.requestAnimationFrame
				|| window.mozRequestAnimationFrame ||
				window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
			window.requestAnimationFrame = requestAnimationFrame;
		}());
		function step(timeStamp) {
			t = Math.min(t + 0.016 / duration, 1);
			const value = ease(t);

			ctx.clearRect(0, 0, 500, 500);

			init();
      
			drawCircles();
			
			if (options.style == 'area') {
				drawAreas();
			}
			
			drawLines();
			if (options.style == 'lines') {
				drawData(value);
			}
      
			drawText(value);

			ctx.restore();
			if (t < 1) {
				window.requestAnimationFrame(step);
			}
		}
		window.requestAnimationFrame(step);
	})();
}


function mounted() {
	const canvas = document.getElementById(`canvas-${this.areaId}`);
	const maxValueSort = this.data.sort((a, b) => b.value - a.value);
	const maxValueSortZero = maxValueSort.length > 0 ? maxValueSort[0] : {};
	const maxValue = maxValueSortZero.value;
	const option = {
		radius: this.radius,
		lines: 5,
		maxValue,
		ease: (t) => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
		duration: 0.8,
	};
	this.showGraph(this.data, canvas, option);
}

export default {
	name: 'graphic-styles',
	methods: {
		showGraph,
	},
	mounted,
	props: {
		data: {
			type: Array,
			default: () => [],
		},
		areaId: Number,
		width: Number,
		radius: Number,
	},
};
</script>




// WEBPACK FOOTER //
// src/components/diagnosis/graphic-styles.vue